export default __webpack_public_path__ + "img/program3.791af0b1.svg";